module.exports = {"522727001":"金盆街道","522727100":"平舟镇","522727101":"牙舟镇","522727102":"通州镇","522727103":"大塘镇","522727104":"克度镇","522727105":"塘边镇","522727106":"甲茶镇","522727107":"者密镇","522727108":"掌布镇","522727200":"卡蒲毛南族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522727.json
// module id = 2344
// module chunks = 0